import React, {useRef, useState} from 'react';
import {TransformComponent, TransformWrapper} from "react-zoom-pan-pinch";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

/**
 * Composant de Img
 */
export default function OImg ({responsive, src, withZoom, className: propClassname, wrapperClassName: propWrapperClassName = null, onUpdateBookmark, bookmark, routeBookmark, height = null, width = null, alt = null}) {

    const refKey = useRef();
    const [isFullscreen, setIsFullscreen] = useState(false);
    // const [transformWrapperProps, setTransformWrapperProps] = useState({
    //     positionX: 0,
    //     positionY: 0,
    //     scale: 1,
    // });

    // /**
    //  * Calculate & Update state of new dimensions
    //  */
    // const updateDimensions = (event) => {
    //     setTransformWrapperProps({
    //         positionX: 0,
    //         positionY: 0,
    //         scale: 1,
    //     });
    // };

    const toggleFullscreen = () => {
        setIsFullscreen(!isFullscreen)
    }

    // componentDidMount() {
    //     this.updateDimensions(null);
    //     window.addEventListener("resize", this.updateDimensions.bind(this));
    // }
    //
    // /**
    //  * Remove event listener
    //  */
    // componentWillUnmount() {
    //     window.removeEventListener("resize", this.updateDimensions.bind(this));
    // }

    // useEffect(() => {
    //     const element = refKey.current;
    //     console.log("coucou");
    //     element.addEventListener("resize", updateDimensions);
    //     return () => {
    //         element.removeEventListener("resize", updateDimensions);
    //     }
    // }, []);

    let className = 'img-fluid ';
    if (typeof responsive !== 'undefined' && !responsive) {
        className = className.replace('img-fluid ', '')
    }

    if (typeof propClassname !== 'undefined') {
        className += propClassname;
    }

    let imgSrc = src;

    if (typeof imgSrc !== 'undefined' && !imgSrc.includes('data:image')) {
        imgSrc = import.meta.env.VITE_MEDIA_URL + imgSrc;
    }

    if (typeof imgSrc === "undefined") {
        return null;
    }

    const isCurrentPageBookmarked = routeBookmark?.id === bookmark?.id;

    if (typeof withZoom !== 'undefined' && withZoom) {
        let wrapperClass = 'zoomable-img ' + propWrapperClassName;
        if (typeof isFullscreen !== 'undefined' && isFullscreen) {
            wrapperClass += ' fullscreen';
        }

        return (
            <div
                onContextMenu={(e) => e.preventDefault()}
                className={wrapperClass}
                ref={refKey}>
                <TransformWrapper
                    doubleClick={{ mode: "reset" }}
                    defaultScale={1}
                >
                    {({resetTransform}) => {
                        return (
                            <React.Fragment>
                                    <span className="expandBtn" onClick={() => {
                                        setTimeout(() => {
                                            resetTransform();
                                        }, 350);
                                        toggleFullscreen();
                                    }}>
                                        <FontAwesomeIcon icon={["fas", isFullscreen ? "compress" : "expand"]}/>
                                    </span>
                                {onUpdateBookmark && <span className={isCurrentPageBookmarked ? "bookmarkBtn tertiary" : "bookmarkBtn" } onClick={() => {
                                    if (isCurrentPageBookmarked) {
                                        onUpdateBookmark({id: null, label: null, url: null});
                                    } else {
                                        onUpdateBookmark(routeBookmark);
                                    }
                                }}>
                                        <FontAwesomeIcon icon={["fas", "bookmark"]}/>
                                    </span>}
                                <TransformComponent>
                                    <img src={imgSrc}
                                         onContextMenu={() => {return false;}}
                                         className={className}
                                         width={width}
                                         height={height}
                                         alt={alt}/>
                                </TransformComponent>
                            </React.Fragment>
                        )
                    }}
                </TransformWrapper>
            </div>
        );
    } else {
        //console.log(imgSrc, className, propWrapperClassName, width, height, alt, refKey);
        return (
            <div
                ref={refKey}
                 className={propWrapperClassName}
            >
                {/*<Suspense>*/}
                {/*    <MyImageComponent imgSrc={imgSrc}*/}
                {/*        className={className}*/}
                {/*        width={width} height={height}*/}
                {/*        alt={alt}/>*/}
                {/*</Suspense>*/}
                <img src={imgSrc}
                     onContextMenu={() => {return false;}}
                     className={className}
                     width={width}
                     height={height}
                     alt={alt}/>
            </div>
        );
    }
}